import { render, staticRenderFns } from "./after_payment.vue?vue&type=template&id=6d968c7f&"
import script from "./after_payment.vue?vue&type=script&lang=js&"
export * from "./after_payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports